var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/brand-urls.j2"] = require( "macros/brand-urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-account-links.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/header/utility-account-links.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("profileUrl")) {
var t_4 = t_1.profileUrl;
} else {
cb(new Error("cannot import 'profileUrl'")); return;
}
context.setVariable("profileUrl", t_4);
if(t_1.hasOwnProperty("addressUrl")) {
var t_5 = t_1.addressUrl;
} else {
cb(new Error("cannot import 'addressUrl'")); return;
}
context.setVariable("addressUrl", t_5);
if(t_1.hasOwnProperty("ordersUrl")) {
var t_6 = t_1.ordersUrl;
} else {
cb(new Error("cannot import 'ordersUrl'")); return;
}
context.setVariable("ordersUrl", t_6);
if(t_1.hasOwnProperty("wishlistUrl")) {
var t_7 = t_1.wishlistUrl;
} else {
cb(new Error("cannot import 'wishlistUrl'")); return;
}
context.setVariable("wishlistUrl", t_7);
if(t_1.hasOwnProperty("helpUrl")) {
var t_8 = t_1.helpUrl;
} else {
cb(new Error("cannot import 'helpUrl'")); return;
}
context.setVariable("helpUrl", t_8);
output += "\n";
env.getTemplate("macros/brand-urls.j2", false, "core/templates/header/utility-account-links.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("registryUrl")) {
var t_12 = t_9.registryUrl;
} else {
cb(new Error("cannot import 'registryUrl'")); return;
}
context.setVariable("registryUrl", t_12);
output += "\n\n\n    <li class=\"c-utility-toggle__li c-account__menu-item--dashboard\" role=\"menuitem\">\n        <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 5, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "accountUrl"), "accountUrl", context, ["dashboard",runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 5, colno = 129, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-myaccount"])), env.opts.autoescape);
output += "\">\n            ";
output += runtime.suppressValue((lineno = 6, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-dashboard"])), env.opts.autoescape);
output += "\n        </a>\n    </li>\n\n<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 11, colno = 52, runtime.callWrap(t_4, "profileUrl", context, [runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 11, colno = 113, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-myaccount"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 12, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-profile"])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 17, colno = 52, runtime.callWrap(t_5, "addressUrl", context, [runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 17, colno = 113, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-address"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 18, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-address"])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 23, colno = 51, runtime.callWrap(t_6, "ordersUrl", context, [runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 23, colno = 112, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-orderHistory"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 24, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-orderHistory"])), env.opts.autoescape);
output += "\n    </a>\n</li>\n\n<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 29, colno = 53, runtime.callWrap(t_7, "wishlistUrl", context, [runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 29, colno = 114, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-wishLists"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 30, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-wishLists"])), env.opts.autoescape);
output += "\n    </a>\n</li>";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"isSiteOutsideNorthAmerica")) {
output += "<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a\" href=\"";
output += runtime.suppressValue((lineno = 36, colno = 53, runtime.callWrap(t_12, "registryUrl", context, ["account",runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 36, colno = 125, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-registry"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 37, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-registry"])), env.opts.autoescape);
output += "\n    </a>\n</li>";
;
}
output += "<li class=\"c-utility-toggle__li\" role=\"menuitem\">\n    <a class=\"c-utility-toggle__a c-utility__a--sign-out js-signout\" data-qa-signout href=\"#\" data-qa-account-dropdown-nav-item aria-label=\"";
output += runtime.suppressValue((lineno = 43, colno = 141, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-signout"])), env.opts.autoescape);
output += "\">\n        ";
output += runtime.suppressValue((lineno = 44, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_navigation-signout"])), env.opts.autoescape);
output += "\n    </a>\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-account-links.j2"] , dependencies)